module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "flexRight"
  }, _vm._l((_vm.statDatas), function(item) {
    return _c('div', {
      staticClass: "info-box"
    }, [_c('div', {
      staticClass: "desc-info"
    }, [_vm._v(_vm._s(item.desc))]), _c('div', {
      staticClass: "import-info"
    }, [_vm._v(_vm._s(item.num))]), (item.percent) ? _c('div', {
      staticClass: "import-info_percent"
    }, [_vm._v(_vm._s(item.percent.desc) + "   " + _vm._s(item.percent.num) + "%")]) : _vm._e()])
  })), _c('DataTablePageNew', {
    ref: "dataQuery",
    attrs: {
      "mainColumn": "",
      "longColumn": "",
      "title": "",
      "resource": _vm.resource,
      "operation": _vm.operation,
      "operationWidth": 100,
      "tableFullList": _vm.tableFullList,
      "tableInitList": _vm.tableInitList,
      "filterFullList": _vm.filterFullList,
      "filterInitList": _vm.filterInitList,
      "columns": _vm.columns
    },
    on: {
      "getData": _vm.renderData
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0fb4ab90","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/NB/DataQuery.vue
// module id = 1693
// module chunks = 1